import axios from 'axios';
import Entidad from '@/models/Entidad';
import Session from '@/models/Session';
function defaultState() {
	return {
		token: localStorage.getItem('accessToken') || '',
		refreshtoken: localStorage.getItem('refreshToken') || '',
		status: '',
		codent: '',
		codemp: 1,
		adminweb: false,
		agrupactasctes: false,
		ocultamonedas: [],
		userdata: {},
		menu: [],
		change: false,
		config: {
			title: '',
		},
		activeProfile: null,
		activeHost: null,
		tableSessions: [],
		remotetoken: null,
		entidadesLogin: [],
		entidadSelected: {},
		descEntidadSelected: '',
	};
}
const state = defaultState();
const getters = {
	isAuthenticated: state => !!state.token,
	isAdmin: state => state.adminweb,
	authStatus: state => state.status,
	getConfig: state => state.config,
	getActiveHost: state => state.activeHost,
};
const mutations = {
	authSuccess(state: { status: string; token: string }, token: string) {
		state.status = 'success';
		state.token = token;
	},
	setRefresh(state: { refreshtoken: string }, refresh: string) {
		state.refreshtoken = refresh;
	},
	setCodent(state: { codent: number }, codent: number) {
		state.codent = codent;
	},
	setCodemp(state: { codemp: number }, codemp: number) {
		state.codemp = codemp;
	},
	setAdmin(state: { adminweb: boolean }, admin: boolean) {
		state.adminweb = admin;
	},
	setChange(state: { change: boolean }, change_password: boolean) {
		state.change = change_password;
	},
	setOcultamonedas(state: { ocultamonedas: boolean }, ocultamonedas: boolean) {
		state.ocultamonedas = ocultamonedas;
	},
	setAgrupactasctes(state: { agrupactasctes: boolean }, agrupactasctes: boolean) {
		state.agrupactasctes = agrupactasctes;
	},
	setMenu(state: { menu: object[] }, menu: object[]) {
		state.menu = menu;
	},
	setTableSessions(state: { tableSessions: Session[] }, sessions: Session[]) {
		state.tableSessions = sessions;
	},
	setActiveHost(state: { activeHost: string }, value: string) {
		state.activeHost = value;
	},
	unauthenticate(state: { status: string; token: string; activeProfile: number | null; userdata: string }) {
		state.activeProfile = null;
		var a = document.getElementById('linkwhitelabel') as HTMLAnchorElement;
		a.href = '';
	},
	setUserData(state: { userdata: object[] }, userdata: object[]) {
		state.userdata = userdata;
	},
	setConfig(state: { config: object[] }, config: object[]) {
		state.config = config;
	},
	setActiveProfile(state: { activeProfile: number | null }, activeProfile: number) {
		state.activeProfile = activeProfile;
	},
	setDashboardCgi(state: { dashboardCgi: number | null }, dashboardCgi: number) {
		state.dashboardCgi = dashboardCgi;
	},
	setRemoteToken(state: { remotetoken: object[] }, token: object[]) {
		state.remotetoken = token;
	},
	setEntidadesLogin(state: { entidadesLogin: object[] }, entidadesLogin: object[]) {
		state.entidadesLogin = entidadesLogin;
	},
	setEntidadSelected(state: { entidadSelected: Entidad }, entidadSelected: Entidad) {
		state.entidadSelected = entidadSelected;
	},
	setDescEntidadSelected(state: { descEntidadSelected: string }, descEntidadSelected: string) {
		state.descEntidadSelected = descEntidadSelected;
	},
};
const actions = {
	setEntidadSelected({ commit, dispatch }, entidadSelected: Entidad) {
		commit('setEntidadSelected', entidadSelected);
		const desc = entidadSelected.descripcion
			? entidadSelected.descripcion
			: entidadSelected.descri_entidad
			? entidadSelected.descri_entidad
			: entidadSelected.razsoc;
		commit('setDescEntidadSelected', desc);
	},
	setActiveProfile({ commit, dispatch }, activeProfile: number) {
		commit('setActiveProfile', activeProfile);
	},
	setAgrupactasctes({ commit, dispatch }, agrupa: number) {
		commit('setAgrupactasctes', agrupa);
	},
	setDashboardCgi({ commit, dispatch }, dashboardCgi: string) {
		commit('setDashboardCgi', dashboardCgi);
	},
	setAdmin({ commit, dispatch }, admin: boolean) {
		commit('setAdmin', admin);
	},
	async callEntitiesPatron({ commit, dispatch }, query: String): Promise<Entidad[]> {
		const response = await axios.get(`./api/public/proxy/cgi/etenet_entidades?patron=${query}`);
		if (response.data.items) {
			this.entidades = response.data.items;
			return response.data.items;
		}
		return response.data.items;
	},
	async setEntidad({ commit, dispatch }, entidad: number) {
		commit('setCodent', entidad);
	},
	async saveEntityChange({ commit, dispatch }, params: { username: string; entidad: number }) {
		return new Promise((resolve, reject) => {
			axios
				.patch(`./api/public/proxy/usuarios/${params.username}`, {
					entidad: params.entidad,
					actua_como: true,
				})
				.then(async response => {
					commit('setCodent', params.entidad);

					resolve(true);
				})
				.catch(() => {
					reject();
				});
		});
	},
	async setPerfil({ commit, dispatch }, params: { data: object; url: string }): Promise<void> {
		try {
			return await axios.post(params.url, params.data);
		} catch (error) {
			console.log(error);
		}
	},
	setRemoteToken({ commit, dispatch }, token: string): Promise<void> {
		return new Promise((resolve, reject) => {
			commit('setRemoteToken', token);
		});
	},
	register({ commit, dispatch }, register: { nombre: string; apellido: string; email: string; password: string; cuit: number; celular: number }) {
		return true;
	},
	async authenticate_local({ commit, dispatch }, credentials: { password: string; user: string }) {
		return await axios
			.post('./api/public/oauth', {
				client_id: 'master',
				grant_type: 'password',
				password: credentials.password,
				username: credentials.user.toLowerCase().trim(),
			})
			.then(response => {
				if (response.data) {
					axios.defaults.headers.common.Authorization = `Bearer ${response.data.access_token}`;
					commit('authSuccess', response.data.access_token);
					commit('setRefresh', response.data.refresh_token);
					//TODO: ver esta guardando el mail en codent
					commit('setCodent', credentials.user);
					localStorage.setItem('accessToken', response.data.access_token);
					localStorage.setItem('refreshToken', response.data.refresh_token);
					return true;
				}
			})
			.catch(() => {
				return false;
			});
	},
	async newSession({ commit, dispatch }, params: { cuit: string; cuitentidad: string }): Promise<void> {
		try {
			const r = await axios
				.post('./api/public/sessions/newsession', {
					cuit: params.cuit,
					cuitentidad: params.cuitentidad,
				})
				.then(async response => {
					commit('setEntidadesLogin', response.data.entidades);
					return response.data;
				})
				.catch(() => {});
			return r;
		} catch (error) {
			console.log('ERROR', error);
		}
	},
	async buscoEntidad({ commit, dispatch }, params: { cuit: string }): Promise<void> {
		try {
			const r = await axios
				.get('./api/public/sessions/buscoentidad?cuit=' + params.cuit)
				.then(async response => {
					commit('setEntidadesLogin', response.data.entidades);
					return response.data;
				})
				.catch(() => {});
			return r;
		} catch (error) {
			console.log('ERROR', error);
		}
	},
	async deleteSession({ commit, dispatch }, params: { cuit: string }) {
		try {
			const r = await axios
				.delete('./api/public/sessions/deletesession?cuit=' + params.cuit)
				.then(async response => {
					return response.status;
				})
				.catch(() => {});
			return r;
		} catch (error) {
			console.log('ERROR', error);
		}
	},
	getActiveSessions({ commit, dispatch }, params: { mobile: boolean }): Promise<boolean> {
		return new Promise((resolve, reject) => {
			let url = `./api/public/sessions/sessions`;
			axios
				.get(url, {
					headers: {
						Authorization: `Bearer ${this.state.perfil.token}`,
					},
				})
				.then(response => {
					commit('setTableSessions', response.data.sessions);
					resolve(true);
				});
		});
	},
	async getUserData({ commit, dispatch }, params: { mobile: boolean; cuit: string; codent: string }) {
		try {
			let url = `./api/public/data?mobile=${params.mobile}`;
			let $actua = params.codent ? params.codent : '';
			const r = await axios
				.get(url, {
					headers: {
						Authorization: `Bearer ${this.state.perfil.token}`,
						Cooperativa: params.cuit,
						Actua_como: $actua,
					},
				})
				.then(response => {
					if (response.data.success) {
						commit('setCodemp', response.data.usuario.codemp);
						commit('setCodent', response.data.usuario.codent);
						commit('setChange', response.data.usuario.change_password);
						commit('setAgrupactasctes', response.data.usuario.agrupactasctes);
						commit('setOcultamonedas', response.data.usuario.ocultamonedas);
						commit('setMenu', response.data.menu);
						commit('setUserData', response.data.usuario);
						if (response.data.usuario.perfiles && response.data.usuario.perfiles.length === 1) {
							commit('setActiveProfile', response.data.usuario.perfiles[0].id);
							commit('setDashboardCgi', response.data.usuario.perfiles[0].cgi);
						}
					}
					return response;
				})
				.catch(() => {
					this.$notify.error({
						title: 'Error',
						message: 'Error al consultar datos del usuario',
						position: 'top-right',
					});
					return {};
				});
			return r;
		} catch (error) {
			console.log('ERROR', error);
		}
	},
	logout({ commit, dispatch }, user): Promise<boolean> {
		return new Promise((resolve, reject) => {
			commit('setEntidadSelected', null);
			axios
				.delete('./api/public/revocation/' + this.state.perfil.token)
				.then(() => {
					localStorage.removeItem('accessToken');
					localStorage.removeItem('refreshToken');
					delete axios.defaults.headers.common.Authorization;
					commit('unauthenticate');
					resolve(true);
				})
				.catch(() => {
					localStorage.removeItem('accessToken');
					localStorage.removeItem('refreshToken');
					window.location.reload();
				});
		});
	},

	setActiveHost({ commit }, host: string): Promise<boolean> {
		return new Promise((resolve, reject) => {
			commit('setActiveHost', host);
			resolve(true);
		});
	},
	// reset(): void {
	// 	Object.assign(state, defaultState());
	// },
};

export default {
	state,
	getters,
	actions,
	mutations,
};
